(() => {
  'use strict';

  const snapshotApi = window.CosmeauProductSnapshot;
  if (!snapshotApi) return;
  const { clean, iconFor, sentenceSummary } = snapshotApi;
  const i18n = window.CV6_PDP_I18N || {};

  const findLead = () => document.querySelector([
    '.cv6-default-summary .short-desc',
    '.v6wp-hero__summary .short-desc',
    '.v6wp-hero__buybox .short-desc',
    '.v6gp__buybox .cv6-g6__lead',
    '.cv6-g6__buybox .cv6-g6__lead'
  ].join(','));

  const findShell = lead => lead?.closest([
    '.cv6-default-summary',
    '.v6wp-hero__summary',
    '.v6wp-hero__buybox',
    '.v6gp__buybox',
    '.cv6-g6__buybox'
  ].join(',')) || lead?.parentElement;

  const openDescription = event => {
    event.preventDefault();
    const outer = document.querySelector('#cv6-product-description');
    if (!outer) return;
    outer.open = true;
    const first = outer.querySelector('.cv6-desc-topic');
    if (first) first.open = true;
    history.replaceState(null, '', '#cv6-product-description');
    requestAnimationFrame(() => requestAnimationFrame(() => outer.scrollIntoView({ behavior: 'smooth', block: 'start' })));
  };

  const build = (lead, target) => {
    if (document.querySelector('.cv6-pdp-choice-snapshot')) return false;
    const proof = document.querySelector('[data-cv6-bestseller-conversion]');
    const productId = document.querySelector('[data-cv6-default-pdp][data-product-id]')?.dataset.productId
      || document.querySelector('[data-cv6-bestseller-conversion]')?.dataset.productId;
    const localizedHandle = clean(location.pathname.split('/products/')[1]?.split('/')[0]).toLowerCase();
    const isSubscriptionTemplate = String(document.body.dataset.cv6TemplateSuffix || '').endsWith('-subscriptions');
    if (isSubscriptionTemplate) return false;
    const locale = (document.documentElement.lang || 'nl').toLowerCase().split('-')[0];
    const resolvedSnapshot = snapshotApi.resolveSnapshot({ productId, productHandle: localizedHandle, locale, target });
    if (!resolvedSnapshot.hasOverride && (!lead || !target)) return false;
    const benefits = resolvedSnapshot.benefits;
    if (benefits.length < 3) return false;
    const shell = findShell(lead) || proof?.parentElement;
    if (!shell && !proof) return false;

    const summaryText = resolvedSnapshot.summary || (lead ? sentenceSummary(lead.querySelector('.short-desc__text')?.textContent || lead.textContent) : '');
    const section = document.createElement('section');
    section.className = 'cv6-pdp-choice-snapshot';
    section.setAttribute('aria-label', i18n.choiceAria || 'Why choose this product');
    section.dataset.cv6ChoiceSnapshot = 'ready';

    const grid = document.createElement('div');
    grid.className = 'cv6-pdp-choice-snapshot__grid';
    benefits.forEach(text => {
      const item = document.createElement('div');
      item.className = 'cv6-pdp-choice-snapshot__item';
      const icon = document.createElement('span');
      icon.className = 'cv6-pdp-choice-snapshot__icon';
      icon.setAttribute('aria-hidden', 'true');
      const resolvedIcon = iconFor(text);
      icon.textContent = resolvedSnapshot.hasOverride && resolvedIcon === '✓' ? '✅' : resolvedIcon;
      const copy = document.createElement('span');
      copy.textContent = text;
      item.append(icon, copy);
      grid.append(item);
    });
    section.append(grid);

    if (summaryText) {
      const summary = document.createElement('p');
      summary.className = 'cv6-pdp-choice-snapshot__summary';
      summary.append(document.createTextNode(summaryText));
      if (isSubscriptionTemplate) {
        summary.append(document.createTextNode(' '));
        const more = document.createElement('a');
        more.className = 'cv6-pdp-choice-snapshot__more';
        more.href = '#cv6-product-description';
        more.textContent = i18n.readMore || 'Read more';
        more.dataset.cv6OpenDescription = '';
        more.addEventListener('click', openDescription);
        summary.append(more);
      }
      section.append(summary);
    }

    const stock = lead ? shell?.querySelector('.v6gp__availability, [data-v6wp-availability], .cv6-default-availability, .cv6-g6__availability') : null;
    const stockRow = stock?.closest('.cv6-default-header-meta, .v6wp-hero__meta') || stock;
    if (stockRow) stockRow.insertAdjacentElement('afterend', section);
    else if (proof) proof.insertAdjacentElement('beforebegin', section);
    else if (lead) lead.insertAdjacentElement('beforebegin', section);
    else return false;
    if (lead && lead !== proof) {
      lead.hidden = true;
      lead.setAttribute('aria-hidden', 'true');
    }
    return true;
  };

  const init = (attempt = 0) => {
    const lead = findLead();
    const target = document.querySelector('#cv6-product-description [data-cv6-desc-target]');
    if (build(lead, target)) return;
    if (attempt < 30) setTimeout(() => init(attempt + 1), 120);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', () => init());
})();
